module.exports = __webpack_public_path__ + "static/media/eclos-brand-catalog-img.f1e82e54.png";